import { PointerSensor, useSensor, useSensors } from '@dnd-kit/core'

export function useKanbanSensors() {
  return useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }))
}
